exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".submit-button[data-v-354b6008]{color:#fff!important;line-height:1.45!important;font-weight:700!important;font-size:18px!important;text-transform:none!important;-webkit-box-shadow:none!important;box-shadow:none!important;height:65px;background-color:#00ba57!important;text-align:center;display:table-cell;vertical-align:middle;padding:0!important;margin:0;border-radius:100px;border:1px solid transparent}.submit-button[data-v-354b6008] .v-btn__content{white-space:pre-wrap;padding:0 70px;line-height:1.1}[data-v-354b6008] h1{font-size:65px;font-family:SFPro;line-height:1.1;font-weight:700;color:#000}[data-v-354b6008] h2,h3[data-v-354b6008]{font-family:SFProBold}[data-v-354b6008] h2{font-size:28px}[data-v-354b6008] h3{font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-354b6008","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/b2b/PasswordReset.vue
// module id = tIVJ
// module chunks = 0